import { render, staticRenderFns } from "./section-cant-suman.vue?vue&type=template&id=81a149d8&scoped=true"
import script from "./section-cant-suman.vue?vue&type=script&lang=js"
export * from "./section-cant-suman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a149d8",
  null
  
)

export default component.exports